/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import find from 'lodash/find'

export default {
  getRegionByCode: state => ({ regionCode, countryID }) => {
    if (state.countries.length) {
      const countryFound = find(state.countries, { id: countryID })
      if (countryFound) {
        const regionFound = find(countryFound.available_regions, { code: regionCode })
        return regionFound || {
          id: 0,
          code: regionCode
        }
      }
    }
    return {}
  },
  total (state) {
    return state.cart.prices ? state.cart.prices.grand_total : 0
  },
  getStepPosition (state) {
    return state.stepPosition
  },
  email (state) {
    return state.cart.email
  },
  needInvoice (state, getters, rootState) {
    let enableReqInvoice = rootState.storeConfig.config ? rootState.storeConfig.config.requestInvoiceSettings.is_enabled : false
    if (enableReqInvoice) {
      let threshold = parseFloat(rootState.storeConfig.config.requestInvoiceSettings.threshold)
      return getters.total && getters.total.value >= threshold
    }
    return false
  },
  getActivePaymentMethod (state) {
    return state.paymentMethod.current
  }
}
